<svg [attr.aria-label]="ariaLabel" [attr.role]="role" [ngClass]="classes">
  <use [attr.href]="spritePath + '#' + icon"></use>
</svg>
